<template>
  <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">Realizar cobrança</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="2">Cobrança Realizada</v-stepper-step>

    </v-stepper-header>
    <v-stepper-items>
      <!-----------------tela 1------------------------->
      <v-stepper-content step="1" class="pa-0">
      <v-card :loading="loading">
          <v-toolbar color="green" dark>
              <v-toolbar-title>Informe o valor da cobrança</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
              <v-layout justify-center class="mb-4">
                <v-flex xs5>
                  <v-select
                    :items="meiosPagamento"
                    item-value="forma_pagamento.descricao"
                    item-text="forma_pagamento.descricao"
                    hide-details
                    solo
                    v-model="meioSelecionado"
                    style="text-transform: uppercase;"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-space-around fill-height>
              </v-layout>
              <v-layout row wrap justify-space-around fill-height>
                <v-flex xs12>
                <v-text-field
                    ref="valor_final"
                    prefix="R$"
                    label="Valor cobrança"
                    v-money="money"
                    v-model.lazy="valor"
                />
                <h4
                  v-if="
                    meioSelecionado && meioSelecionado.toLowerCase() === 'pagpixbank' &&
                    converterValor(valor) < 0.30
                  "
                  class="error--text text-xs-center"
                >
                  Só são permitidas transações acima de R$ 0,29 centavos
                </h4>
                <h4
                  v-if="
                    meioSelecionado && meioSelecionado.toLowerCase() === 'bancointer' &&
                    converterValor(valor) < 0.01
                  "
                  class="error--text text-xs-center"
                >
                  Não é possivel fazer uma cobrança com este valor
                </h4>
              </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn flat color="red" @click="$emit('fechar')">Fechar</v-btn>
                <v-spacer></v-spacer>
              <v-btn
                flat
                color="primary"
                @click="function () {
                    if (meioSelecionado.toLowerCase() === 'efipix') criarCobranca()
                    else if (meioSelecionado.toLowerCase() === 'pagpixbank') gerarQRCodePagPix()
                    else if (meioSelecionado.toLowerCase() === 'bancointer') criarCobrancaInter()
                  }
                "
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-stepper-content>
      <!-----------------fim tela 1------------------------->
      <v-stepper-content step="2" class="pa-0">
        <v-card :loading="loading">
        <v-toolbar color="green" dark>
            <v-toolbar-title>Cobrança gerada</v-toolbar-title>
        </v-toolbar>
        <v-card-text id="print">
            <v-layout v-if="loading && !qrcode" row wrap justify-space-around fill-height>
                <h3 class="text-xs-center red--text">Por favor! Aguarde a geração do Qrcode</h3>
            </v-layout>
            <v-layout v-else row wrap justify-space-around fill-height>
            <h3 class="text-xs-center green--text">Mostre ou imprima o comprovante para uso do cliente!</h3>
            <v-img id="mainImg"
                :lazy-src="qrcode"
                height="400"
                width="400"
                :src="qrcode"
                v-if="qrcode"
            ></v-img>
            <v-btn
                rounded
                color="green"
                dark
                @click="printData()"
              >
              Imprimir
            </v-btn>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="red" @click="cancelar">Cancelar</v-btn>
            <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="cancelar">Finalizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>

import { VMoney } from 'v-money'
import * as Printjs from 'print-js'

export default {
  props: ['frentistaSelecionado'],
  data () {
    return {
      step: 0,
      infoPosto: {
        endereco: {},
        representante: {}
      },
      pwin: null,
      carregado: false,
      valor: null,
      valor_formatado: null,
      aprovar: true,
      meiosPagamento: [],
      meioSelecionado: undefined,
      txid: undefined,
      interval: undefined,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  watch: {
    valor (val) {
      if (val !== null || val !== undefined) {
        this.valor_formatado = this.valor.split('.').join('')
        this.valor_formatado = this.valor_formatado.split(',').join('.')
      }
    }
  },
  beforeMount () {
    this.pegarMeiosDePagamentosSecundarios()
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    frentista () {
      return this.$store.getters.frentista
    },
    qrcode () {
      return this.$store.getters.qrcodecobranca
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    cancelar () {
      if (this.txid) {
        if (this.meioSelecionado.toLowerCase() === 'pagpixbank') {
          this.deletarTransacao()
        } else if (this.meioSelecionado.toLowerCase() === 'efipix') {
        } else if (this.meioSelecionado.toLowerCase() === 'bancointer') {
          this.cancelarTransacaoInter()
        }
      }
      this.clearInput()
      this.$emit('fechar')
    },
    clearInput () {
      this.txid = undefined
      this.valor = null
      this.step = 1
    },
    criarCobranca () {
      const data = {
        valor: this.valor_formatado.toString()
      }
      this.$store.dispatch('inserirCobranca', data).then(json => {
        this.txid = json.txid
        this.interval = setInterval(() => {
          if (!this.txid) clearInterval(this.interval)
          else this.verificarPagamentoPagPix()
        }, 15000)
        this.mudarTela()
      })
    },
    gerarQRCodePagPix () {
      this.txid = undefined
      const data = {
        method: 'POST',
        valor: this.valor_formatado.toString()
      }
      this.$store.dispatch('transacoesPagPixBank', data).then(json => {
        this.txid = json.txid
        this.mudarTela()
        this.interval = setInterval(() => {
          if (!this.txid) clearInterval(this.interval)
          else this.verificarPagamentoPagPix()
        }, 15000)
      })
    },
    criarCobrancaInter () {
      this.txid = undefined
      let payload = {
        valor: this.valor_formatado.toString()
      }
      this.$store.dispatch('criarCobrancaInter', payload).then(json => {
        this.txid = json.txid
        this.mudarTela()
        this.interval = setInterval(() => {
          if (!this.txid) clearInterval(this.interval)
          else this.verificarPagamentoPagPix()
        }, 15000)
      })
    },
    cancelarTransacaoInter () {
      const payload = {
        txid: this.txid
      }
      this.$store.dispatch('cancelarCobrancaInter', payload).then(() => this.clearInput())
    },
    verificarPagamentoPagPix () {
      const data = {}
      if (this.meioSelecionado.toLowerCase() === 'pagpixbank') {
        data.method = 'GET'
        data.txid = this.txid
        this.$store.dispatch('transacoesPagPixBank', data).then(json => {
          if (json.status === 'Aprovada') {
            this.$store.dispatch('setSuccess', { message: 'O cliente realizou o pagamento através do QRcode.', title: 'Pagamento realizado' })
            if (this.interval) clearInterval(this.interval)
            this.clearInput()
            this.cancelar()
          } else if (json.status === 'DEVOLVIDA') {
            this.$store.dispatch('setError', { message: 'Transação cancelada' })
            this.clearInput()
          }
        })
      } else if (this.meioSelecionado.toLowerCase() === 'efipix') {
        data.txid = this.txid
        this.$store.dispatch('listarCobrancas', data).then(json => {
          if (json.status === 'CONCLUIDA' || json.status === 'PAGA') {
            this.$store.dispatch('setSuccess', { message: 'O cliente realizou o pagamento através do QRcode.', title: 'Pagamento realizado' })
            if (this.interval) clearInterval(this.interval)
            this.clearInput()
            this.cancelar()
          } else if (json.status === 'REMOVIDA' || json.status === 'EXPIRADA') {
            this.$store.dispatch('setError', { message: 'Transação cancelada' })
            this.clearInput()
          }
        })
      } else if (this.meioSelecionado.toLowerCase() === 'bancointer') {
        data.txid = this.txid
        this.$store.dispatch('pegarCobrancaInter', data).then(json => {
          if (json.status === 'CONCLUIDA') {
            this.$store.dispatch('setSuccess', { message: 'O cliente realizou o pagamento através do QRcode.', title: 'Pagamento realizado' })
            if (this.interval) clearInterval(this.interval)
            this.clearInput()
            this.cancelar()
          } else if (json.status === 'REMOVIDA_PELO_USUARIO_RECEBEDOR' || json.status === 'REMOVIDA_PELO_PSP') {
            this.$store.dispatch('setError', { message: 'Transação cancelada' })
            this.clearInput()
          }
        })
      }
    },
    deletarTransacao () {
      const data = {
        method: 'DELETE',
        txid: this.txid
      }
      this.$store.dispatch('transacoesPagPixBank', data).then(() => this.clearInput())
    },
    converterValor (valor) {
      return Number(valor.replaceAll('.', '').replace(',', '.'))
    },
    pegarMeiosDePagamentosSecundarios () {
      this.$store.dispatch('pegarMeiosDePagamentosSecundarios').then(json => {
        this.meiosPagamento = json
        if (json.length > 0) {
          this.meioSelecionado = json[0].forma_pagamento.descricao
        }
      })
    },
    mudarTela () {
      this.step = 2
    },
    printData () {
      Printjs(this.qrcode, 'image')
    }
  },
  directives: { money: VMoney }
}
</script>
